import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "slide-aside-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "slide-aside-main",
      style: _normalizeStyle(_ctx.mainTransform)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 4),
    _createVNode(_Transition, {
      name: "aside-slide",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              class: "slide-aside-panel",
              style: _normalizeStyle({ width: _ctx.rightWidth })
            }, [
              _renderSlot(_ctx.$slots, "right", {}, undefined, true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}